import { QueryClient } from '@tanstack/react-query'

// Telemetry pages must not show stale data just because a query was recently
// fetched elsewhere — default to treating data as immediately stale and let
// individual telemetry queries opt into a longer staleTime deliberately
// (e.g. slow-changing config/nav data), rather than the other way around.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
